@if (isMobile) { @if (shimanoDiscountBuckets) {
<div
  class="mobile-shimano-discount-buckets-container d-inline-block"
  display="dynamic"
  placement="bottom-left"
  ngbDropdown
>
  <button class="btn btn-link p-0" id="discountTypeDropdown" ngbDropdownToggle>
    {{ shimanoDiscountBuckets[activeI]?.name }}
    <mat-icon class="material-icons-sharp light md-12 ml-1">expand_more</mat-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="discountTypeDropdown" class="dropdown-menu dropdown-menu-right border-0">
    @for (bucket of shimanoDiscountBuckets; track bucket; let i = $index) {
    <button ngbDropdownItem (click)="onClickDiscountBucket(bucket, i); activeI = i" [class.selected]="activeI === i">
      @if (activeI === i) {
      <mat-icon svgIcon="check" class="md-12 mr-1"></mat-icon>
      } {{ bucket?.name }}
    </button>
    }
  </div>
</div>
} } @else { @if (discountType$ | async) {
<div class="shimano-discount-buckets-container">
  @if (shimanoDiscountBuckets) {
  <mat-nav-list>
    @for (bucket of shimanoDiscountBuckets; track bucket; let i = $index) {
    <a
      mat-list-item
      disableRipple
      [class.selected]="discountBucketActive === bucket.code"
      (click)="onClickDiscountBucket(bucket, i); activeI = i"
    >
      {{ bucket?.name }}
    </a>
    }
  </mat-nav-list>
  }
</div>
} }
